// ORCA-1977: vídeos tutoriais no CDN (Spaces orca2-cdn), versão web e mobile de cada um.
// Para trocar um vídeo, suba com outro nome (o CDN guarda o arquivo em cache) e atualize aqui.
const CDN = 'https://orca2-cdn.nyc3.cdn.digitaloceanspaces.com/videos/webapp';

export interface TutorialVideo {
    web: string;
    mobile: string;
}

export const TUTORIAL_VIDEOS = {
    firstProposal: {
        web: `${CDN}/tutorial-primeiro-orcamento-web.mp4`,
        mobile: `${CDN}/tutorial-primeiro-orcamento-mobile.mp4`,
    },
    customizeProposal: {
        web: `${CDN}/tutorial-personalizar-orcamento-web.mp4`,
        mobile: `${CDN}/tutorial-personalizar-orcamento-mobile.mp4`,
    },
};

// Mesmo limite em todas as telas: até 768 px (celular e app) usa a versão mobile
export function tutorialVideoUrl(video: TutorialVideo, width = window.innerWidth): string {
    return width > 768 ? video.web : video.mobile;
}
